module.exports = __webpack_public_path__ + "static/developer-step1.21ed3674.png";